import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { goRiceUrl } from '../../../../constant/siteConstants';
import getConfigToken from '../../../../utils/getConfigToken';
import useFormatMessage from '../../../../utils/useFormatMessage';
import PermissionTab from '../common/PermissionTab';

export default function UpdateModal({ dataId, modalUpdate, setModalUpdate, updateTrigger, setUpdateTrigger }) {
    const notifySuccess = (message) => toast.success(`${message}`);
    const notifyError = (message) => toast.error(`${message}`);
    const [roleGroups, setRoleGroups] = useState([]);
    const [permissionGroupDatas, setPermissionGroupDatas] = useState([]);
    const [selectedPermissionGroup, setSelectedPermissionGroup] = useState();
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedUserRoles, setSelectedUserRoles] = useState([])
    const { t } = useFormatMessage();
    /// roller
    async function getRoleGroups() {
        await Axios.post(`${goRiceUrl}/api/employee/getAllRolesAndRoleGroup`, {}, getConfigToken).then((resp) => {

            resp.data.forEach(obj => {

                obj.checked = false

            })
            setRoleGroups(resp.data);
        }).then(() => {
            setTimeout(() => {
                getSelectedUserData();
            }, 500);
        }).catch((err) => {
            console.error(err);
            notifyError("Rol Grupları yüklenirken bir servis hatası meydana geldi.");
        })
    }


    async function getPermissionGroups() {
        await Axios.post(`${goRiceUrl}/api/employee/getPermissionGroupsWithRoles`, {}, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                setPermissionGroupDatas(resp.data);
            } else {
                notifyError("Yetki Grupları yüklenirken bir hata meydana geldi.");
            }
        }).catch((err) => {
            console.error(err);
            notifyError("Yetki Grupları yüklenirken bir servis hatası meydana geldi.");
        })
    }

    async function getSelectedUserData() {
        await Axios.post(`${goRiceUrl}/api/employee/getRoles`, {
            employee_id: dataId
        }, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                setSelectedUserRoles(resp.data.permissions) // TODO: USerRole permission mudur roles midir
                if (resp.data.special_roles !== null) {
                    var arr = []
                    resp.data.special_roles.forEach(role => {
                        arr.push(role.role_id)
                        // document.getElementById(`${role.RoleId}_checkbox`).checked = true;

                    })
                    setSelectedRowKeys(arr)
                }
                if (resp.data.permissions !== null) {
                    const dataHolder = []
                    resp.data.permissions.forEach((item) => {
                        dataHolder.push(item.permission_group_id)
                    })
                    setSelectedPermissionGroup(dataHolder);
                    //  setSelectedPermissionGroup(resp.data.PermissionGroups[0].YetkiGrupId);
                }
                setTimeout(() => {
                    if (document.getElementById("username_div")) {
                        document.getElementById("username_div").innerHTML = resp.data.full_name; //TODO
                    }
                }, 300);

            } else {
                notifyError("Seçilen Kullanıcı verisi yüklenirken bir hata meydana geldi.");
            }
        })
            .catch((err) => {
                console.error(err);
                notifyError("Seçilen Kullanıcı verisi yüklenirken bir servis hatası meydana geldi.");
            })
    }

    async function configureUserRoles() {
        // const checkboxHolder = []
        // var arr = Array.from(document.getElementsByClassName("role_checkbox_new"));
        // arr.filter(element => element.checked === true).map(checks => {
        //     checkboxHolder.push(parseInt(checks.id.split("_")[0]));
        // })
        const checkboxHolder = []
        var arr = Array.from(selectedRowKeys);
        arr.forEach(checks => {
            checkboxHolder.push(checks)
        })

        const filteredPermissionGroup = selectedPermissionGroup.filter(item => item !== null);
        const filteredCheckboxHolder = checkboxHolder.filter(item => item !== null);


        await Axios.post(`${goRiceUrl}/api/employee/updateRoles`, {
            "employee_id": [dataId],
            "permission_group_ids": filteredPermissionGroup,
            "special_role_ids": filteredCheckboxHolder,
            "user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))

        }, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                setUpdateTrigger(!updateTrigger);
                setModalUpdate(false);
                notifySuccess("Yetki Grubu Ataması başarıyla güncellendi");
            } else {
                notifyError("Yetki Grubu eklenirken bir hata meydana geldi.");
            }
        }).catch((err) => {
            console.error(err);
            notifyError("Yetki Grubu eklenirken bir servis hatası meydana geldi.");
        })
    }

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (modalUpdate === true) {
            getRoleGroups();
            getPermissionGroups();
        }
    }, [modalUpdate])
    /* eslint-disable react-hooks/exhaustive-deps */

    return (
        <Modal size="lg" isOpen={modalUpdate} toggle={() => { setModalUpdate(!modalUpdate); }}>
            <ModalHeader toggle={() => { setModalUpdate(!modalUpdate); }}>
                {t("Yetki Grubu Güncelleme Formu")}
            </ModalHeader>
            <ModalBody>
                <PermissionTab selectedUserRoles={selectedUserRoles} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys} roleGroups={roleGroups} permissionGroupDatas={permissionGroupDatas} selectedPermissionGroup={selectedPermissionGroup} setSelectedPermissionGroup={setSelectedPermissionGroup} isUpdateModal={true} />
            </ModalBody>
            <ModalFooter>
                <Col lg="12" className='d-flex justify-content-between align-items-center' >
                    <Button id='saveButtonNew' disabled={false} onClick={() => { configureUserRoles(); document.getElementById("saveButtonNew").disabled = true }} >Kaydet</Button>
                    <Button id='cancelButtonNew' color='danger' onClick={() => { setModalUpdate(false) }} >İptal</Button>
                </Col>
            </ModalFooter>
        </Modal>
    )
}